export default __webpack_public_path__ + "9cc9045a4083053922374fb5a0c261b8.png";